import clx from 'classnames';
import BigDivider from '@/atoms/BigDivider';
import MainTitle from '@/molecules/titles/MainTitle';
import { ALIGNMENT_ENUM, SIZE } from 'types/utils';
import { CMSTitle } from 'utils/cms/types';

type BigDividerProps = {
  title?: CMSTitle;
  divider_position?: 'before' | 'after';
  divider_size?: SIZE;
};

const BigDividerTitle = ({
  title,
  divider_position: position = 'before',
  divider_size: size = SIZE.LG,
}: BigDividerProps) => (
  <div
    className={clx(
      'flex items-center text-center',
      position === 'before' ? 'flex-col-reverse gap-6' : 'flex-col gap-8',
    )}
  >
    {title?.main_title && (
      <MainTitle
        {...title}
        alignment={ALIGNMENT_ENUM.center}
        iconVariant={title.icon_variant}
        showLine={title.show_line}
        size={title.title_size}
      >
        {title.main_title}
      </MainTitle>
    )}

    <BigDivider size={size} />
  </div>
);
export default BigDividerTitle;
